import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";
import size from "lodash-es/size";

Vue.use(Vuex);

interface RentDetails extends Vue {
    id: string;
    details: object;
    fetchDetails: () => void;
}

const RentDetails = {
    template: "#rentDetails",
    name: "RentDetails",
    props: ["id"],
    computed: {
        details: {
            get(this: RentDetails) { return this.$store.state.details; },
            set(this: RentDetails, value) { this.$store.commit("updateDetails", value); },
        },
    },
    watch: {
        $route: "fetchDetails",
    },
    mounted(this: RentDetails) {
        this.fetchDetails();
    },
    destroyed(this: RentDetails) {
        this.details = {};
    },
    methods: {
        async fetchDetails() {
            const json = await fetch(`${window.$$currentPath}/.rest/wgn/v1/rent/detail`, {
                method: "PUT",
                // @ts-ignore: no Headers on IE
                headers: {"Content-Type": "application/json"},
                credentials: "same-origin",
                mode: "cors",
                cache: "no-store",
                body: JSON.stringify({ uuid: this.id }),
            }).
            then((r: any) => r.ok ? r.json() : null);

            if (json && !("carousel" in json) && size(json.images) > 0) {
                json.carousel = [];

                json.images.forEach((image: HTMLImageElement) => {
                    json.carousel.push({
                        content: "",
                        image,
                    });
                });
            }

            if (json && !("rentBrutto" in json) && json.rentNet && parseFloat(json.rentNet)) {
                json.rentBrutto = parseFloat(json.rentNet);
                if (json.rentExtra && parseFloat(json.rentExtra)) {
                    json.rentBrutto = json.rentBrutto + parseFloat(json.rentExtra);
                }
            }

            if (json && !("availableDate" in json) && json.availableFrom) {
                let d = json.availableFrom.split(".");
                if (d.length === 3) {
                    const detailsDate = new Date(d[2] + "-" + d[1] + "-" + d[0] + "T00:00:00.000Z");
                    const today = new Date();
                    today.setUTCHours(0, 0, 0, 0);
                    json.availableDate = today >= detailsDate ? "Sofort" : json.availableFrom;
                } else {
                    json.availableDate = json.availableFrom;
                }
            }

            if (json && !("floorString" in json) && json.floor) {
                let floorNb = 0;
                floorNb = parseInt(json.floor);
                if (!isNaN(floorNb) && floorNb !== 99) {
                    if (floorNb === 0) {
                        json.floorString = "Erdgeschoss";
                    } else {
                        json.floorString = floorNb > 0 ? json.floor + ". OG" : Math.abs(json.floor) + ". UG";
                    }
                }
                else {
                    json.floorString = "";
                }
            }

            this.details = json;
        },

        // enter fullscreen
        enterFullscreen() {
            const section = this.$el.querySelector( ".o-fullscreen" );
            if ( section ) section.classList.add( "fullscreen" );

            const element = this.$el.querySelector(".fullscreen-container");

            if ( element ) {
                if ( element.requestFullscreen ) {
                    element.requestFullscreen();
                } else if ( (element as any).mozRequestFullScreen ) {
                    (element as any).mozRequestFullScreen();
                } else if ( (element as any).msRequestFullscreen ) {
                    (element as any).msRequestFullscreen();
                } else if ( element.webkitRequestFullScreen ) {
                    element.webkitRequestFullScreen();
                }

                const exit = this.$el.querySelector( ".fullscreen-btn.exit" );
                const enter = this.$el.querySelector( ".fullscreen-btn.enter" );
                if ( enter ) (enter as HTMLElement).style.display = "none";
                if ( exit ) (exit as HTMLElement).style.display = "block";
            }

        },

        // exit fullscreen
        exitFullscreen() {
            const section = this.$el.querySelector( ".o-fullscreen" );
            if ( section ) section.classList.remove( "fullscreen" );

            if ( document.exitFullscreen ) {
                document.exitFullscreen();
            } else if ( (document as any).mozCancelFullScreen ) {
                (document as any).mozCancelFullScreen();
            } else if ( document.webkitExitFullscreen ) {
                document.webkitExitFullscreen();
            } else if ( (document as any).msExitFullscreen ) {
                (document as any).msExitFullscreen();
            }

            const exit = this.$el.querySelector( ".fullscreen-btn.exit" );
            const enter = this.$el.querySelector( ".fullscreen-btn.enter" );
            if ( exit ) (exit as HTMLElement).style.display = "none";
            if ( enter ) (enter as HTMLElement).style.display = "block";
        },
    },
} as ComponentOptions<RentDetails>;

export { RentDetails };



// WEBPACK FOOTER //
// ./src/components/rent-details.ts